module.exports = __webpack_public_path__ + "static/covid-96a96414661de1d7aee870b4b1ddc032.jpg";